import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import VModal from 'vue-js-modal'
import FileUpload from 'v-file-upload'
import Notifications from 'vue-notification'


Vue.config.productionTip = false
Vue.use(VModal)
Vue.use(FileUpload)
Vue.use(Notifications)

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
